import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';

export const overlappingEmplFormSubmit = async (
  formId: string,
  data: unknown,
) => {
  try {
    const response = await fetchFromNewApi(
      APIs.forms.formOverlappingEmpSubmission(formId),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      },
    );
    return await response.json();
  } catch (e) {
    // handleFetchResponseValidity throws the raw Response on non-2xx; extract
    // its body so the caller can show the backend error message.
    if (e instanceof Response) {
      const body = await e.json().catch(() => undefined);
      const error = new Error(
        body?.message ?? `Submission failed (${e.status})`,
      );
      (error as Error & { status: number; body: unknown }).status = e.status;
      (error as Error & { status: number; body: unknown }).body = body;
      throw error;
    }
    throw e;
  }
};
